const t = {
  name: "Mail",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 6C0 4.34315 1.34315 3 3 3H21C22.6569 3 24 4.34315 24 6V18C24 19.6569 22.6569 21 21 21H3C1.34314 21 0 19.6569 0 18V6ZM2 17.5859L7.58586 12L2 6.41415V17.5859ZM3.4143 19H20.5858L15.0001 13.4142L14.1214 14.2929C12.9498 15.4645 11.0503 15.4645 9.87875 14.2929L9.00008 13.4142L3.4143 19ZM16.4143 12L22 17.5857V6.4143L16.4143 12ZM3.41427 5L11.293 12.8787C11.6835 13.2692 12.3167 13.2692 12.7072 12.8787L20.5859 5H3.41427Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Mail
};
